import { useApi, createApiHook } from "../utils/apiUtils";

const useBulkCreateAssignapps = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const createAssignapps = async (body) => {
    startLoading();

    const resp = await apiPost("/assignapps/bulk_create", "Error al crear asignaciones", body);

    setResponse(resp);

    if (resp.error) {
      return {
        ok: false,
        errorMessage: resp.error.message || "No se pudo crear las asignaciones.",
        status: resp.error.status,
      };
    }

    return { ok: true, data: resp.data };
  };

  return { createAssignapps, data, error, loading };
};

export default useBulkCreateAssignapps;
